import React from "react";
import { Ribbon } from "@/components/Ribbon";
import { SideNav } from "@/components/SideNav";
import { TrialBanner } from "@/components/TrialBanner";
import { useBranding } from "@/context/BrandingContext";
import { VideraMark } from "@/components/VideraMark";

export const Shell = ({ children, title, subtitle, actions, testId, minimal = false }) => {
  const { t } = useBranding();
  return (
  <div className="min-h-screen bg-background">
    <TrialBanner />
    <Ribbon minimal={minimal} />
    <div className="flex">
      {!minimal && <SideNav />}
      <main data-testid={testId} className="min-w-0 flex-1 px-6 py-8">
        {(title || actions) && (
          <div className="mb-7 flex flex-wrap items-end justify-between gap-4 stagger-in">
            <div>
              <h1 className="text-3xl font-bold text-slate-900 sm:text-4xl">{t(title)}</h1>
              {subtitle && <p className="mt-1 text-sm text-slate-500">{t(subtitle)}</p>}
            </div>
            <div className="flex items-center gap-2">{actions}</div>
          </div>
        )}
        {children}
        <div data-testid="videra-strapline"
          className="mt-14 flex items-center gap-2 border-t border-slate-200 pt-4 text-[11px] uppercase tracking-[0.18em] text-slate-400">
          <VideraMark size={14} className="text-slate-300" />
          Operational Excellence — powered by Videra Technology
        </div>
      </main>
    </div>
  </div>
  );
};

export const Empty = ({ text, testId }) => (
  <div data-testid={testId} className="panel px-6 py-14 text-center text-sm text-slate-500">
    {text}
  </div>
);
